import React, { useContext } from 'react';
import Popper from '../../Popover/PopperPopover/Popper';
import { DropdownStateContext } from '../DropdownStateManager';
var PopperDropdownContent = function (_a) {
    var usePortal = _a.usePortal, _b = _a.placement, placement = _b === void 0 ? 'bottom-end' : _b, modifiers = _a.modifiers, children = _a.children, role = _a.role, className = _a.className, ariaLabel = _a["aria-label"];
    var _c = useContext(DropdownStateContext), isOpen = _c.isOpen, setMenuRef = _c.setMenuRef, closeDropdown = _c.closeDropdown;
    return (React.createElement(Popper, { isOpen: isOpen, usePortal: usePortal, positionOnly: true, placement: placement, innerRef: setMenuRef, modifiers: modifiers, className: className, onKeyDown: function (e) {
            switch (e.key) {
                case 'Escape':
                    closeDropdown();
                    break;
                default:
                    break;
            }
        }, role: role, "aria-label": ariaLabel }, children));
};
PopperDropdownContent.displayName = 'PopperDropdownContent';
export default PopperDropdownContent;
//# sourceMappingURL=PopperDropdownContent.js.map